import { render, staticRenderFns } from "./106ycyh.vue?vue&type=template&id=2706e62c&"
import script from "./106ycyh.vue?vue&type=script&lang=js&"
export * from "./106ycyh.vue?vue&type=script&lang=js&"
import style0 from "./106ycyh.vue?vue&type=style&index=0&id=2706e62c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports